import React, { FC, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { ArrowLeftIcon, ChevronDoubleLeftIcon } from '@heroicons/react/outline'
import ROUTES from '../utils/routes'
import { Button, Spinner } from '../System'
import { WidthController, FlexGroup } from '../Grid'
import { StyledLessonView, LessonMap, useCourseHandler, LessonContent } from '.'
import { SkeletonLoader } from '../SkeletonLoader'
import { getCourseCompletedPercentage } from '../CourseLibraryView'

const LessonView: FC = () => {
  const {
    currCourse,
    currModule,
    currLesson,
    nextLesson,
    loading,
    actions: { toggleLessonComplete }
  } = useCourseHandler()

  const [completedPercentage, setCompletedPercentage] = useState(0)
  const [isExpanded, setIsExpanded] = useState(true)

  useEffect(() => {
    const percentage = getCourseCompletedPercentage(currCourse)
    setCompletedPercentage(percentage)
  }, [currCourse])

  if (!currLesson || !currCourse || !currModule) {
    return <Spinner isBlock />
  }

  return (
    <StyledLessonView>
      <Helmet title={currLesson?.title || ''} />
      <WidthController maxWidth={isExpanded ? 910 : 1250} noPadding>
        <div className="lesson-top-bar">
          <Link to={ROUTES.dashboard.courses}>
            <Button theme="ghost" type="small" iconPos="left" className="back-btn">
              <ArrowLeftIcon />
              Back To Course Library
            </Button>
          </Link>
          <FlexGroup>
            {!isExpanded && (
              <div className="completion-bar">
                <label htmlFor="course-progress">{completedPercentage.toFixed(0)}% Completed</label>
                <progress id="course-progress" max="100" value={completedPercentage}>
                  {completedPercentage.toFixed(0)}%
                </progress>
              </div>
            )}
            {!isExpanded && (
              <Button
                onClick={() => setIsExpanded(!isExpanded)}
                theme="outline"
                type="small"
                iconPos="left"
              >
                <ChevronDoubleLeftIcon />
                See All Lessons
              </Button>
            )}
          </FlexGroup>
        </div>
        {loading && <SkeletonLoader type="lesson" />}
        {!loading && (
          <LessonContent
            currCourse={currCourse}
            currModule={currModule}
            currLesson={currLesson}
            nextLesson={nextLesson}
            toggleLessonComplete={toggleLessonComplete}
          />
        )}
      </WidthController>
      {currLesson && (
        <LessonMap
          course={currCourse}
          currentLesson={currLesson}
          isOpen={isExpanded}
          setLessonComplete={toggleLessonComplete}
          setMapOpen={(bool) => setIsExpanded(bool)}
        />
      )}
    </StyledLessonView>
  )
}

export default LessonView
